// removed by extract-text-webpack-plugin
module.exports = {"performaFileUploader":"performaFileUploader--8f650"};